import { Slider, SliderTrack, SliderRange, SliderThumb } from "@radix-ui/react-slider";
import React from "react";
import { useTheme } from "../Theme/ThemeProvider";

/** Slider to select font size for accessibility. Options are small, medium, and large. */
export function ThemeFontSlider() {
    const { fontSize, setFontSize, fontSizeLabels, mode } = useTheme();

    return (
        <div className="flex items-start w-full mt-6 gap-4 flex-col">
            <span className="font-semibold text-sm text-[var(--color-text)] pt-1 w-full text-center">
                Font Size
            </span>
            <div className="flex flex-col w-full">
                <div className="flex items-center w-full">
                    <Slider
                        className="relative flex items-center select-none touch-none w-full h-6"
                        min={0}
                        max={2}
                        step={1}
                        value={[fontSize]}
                        onValueChange={([v]) => setFontSize(v as 0 | 1 | 2)}
                        aria-label="Font Size"
                    >
                        <SliderTrack 
                            className="relative grow rounded-full h-2"
                            style={{ backgroundColor: mode === 'light' ? 'rgba(32, 32, 36, 0.2)' : 'rgba(255, 255, 255, 0.2)' }}
                        >
                            <SliderRange 
                                className="absolute rounded-full h-2" 
                                style={{ backgroundColor: mode === 'light' ? '#202024' : '#ffffff' }}
                            />
                        </SliderTrack>
                        <SliderThumb
                            className="block w-5 h-5 border-2 rounded-full shadow transition focus:outline-none"
                            style={{ 
                                backgroundColor: mode === 'light' ? '#202024' : '#ffffff',
                                borderColor: 'var(--color-bg)'
                            }}
                        />
                    </Slider>
                </div>
                <div className="flex justify-between mt-2 text-xs text-[var(--color-text)]">
                    {fontSizeLabels?.map((label, i) => (
                        <span key={label} className={fontSize === i ? "font-bold text-accent-500" : ""}>
                            {label}
                        </span>
                    ))}
                </div>
            </div>
        </div>
  );
}     